import type { SVGProps } from "react";

export const HowItWorksDecorativeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M17 3v6" />
        <path d="M17 25v6" />
        <path d="M3 17h6" />
        <path d="M25 17h6" />
        <path d="M7.1 7.1l4.2 4.2" />
        <path d="M22.7 22.7l4.2 4.2" />
        <path d="M26.9 7.1l-4.2 4.2" />
        <path d="M11.3 22.7l-4.2 4.2" />
      </g>
    </svg>
  );
};
